var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3818 14H8.76376L7.12676 8H19.3818L16.3818 14ZM21.0828 6.948C20.7158 6.354 20.0798 6 19.3818 6H6.58176L5.96476 3.737C5.84576 3.302 5.45076 3 4.99976 3H2.99976C2.44676 3 1.99976 3.448 1.99976 4C1.99976 4.552 2.44676 5 2.99976 5H4.23576L7.03476 15.263C7.15376 15.698 7.54876 16 7.99976 16H16.9998C17.3788 16 17.7248 15.786 17.8948 15.447L21.1708 8.894C21.4838 8.269 21.4498 7.542 21.0828 6.948ZM7.49996 18C6.67196 18 5.99996 18.671 5.99996 19.5C5.99996 20.329 6.67196 21 7.49996 21C8.32796 21 8.99996 20.329 8.99996 19.5C8.99996 18.671 8.32796 18 7.49996 18ZM16 19.5C16 18.671 16.672 18 17.5 18C18.328 18 19 18.671 19 19.5C19 20.329 18.328 21 17.5 21C16.672 21 16 20.329 16 19.5Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKart);
export default __webpack_public_path__ + "static/media/kart.c961f33af888b211fc4903436167e16e.svg";
export { ForwardRef as ReactComponent };